class UIAccordion {
    constructor(el) {
        this.isOpen = false;
        this.isInGroup = false;
        this.cssHeightProperty = '--ui-accordion-collapse-max-h';

        this.elements = {
            accordion: el,
            btn: el.querySelector('.ui-accordion__btn'),
            collapse: el.querySelector('.ui-accordion__collapse'),
            group: el.closest('.ui-accordion__group'),
        };

        this.ID = this.elements.btn.getAttribute('aria-controls');

        this.addInGroup();
        this.listenToggle();
        this.listenHashChange();

        this.handleHashChange();
    }

    get isClosed() {
        return !this.isOpen;
    }

    set isClosed(bool) {
        this.isOpen = !bool;
    }

    open() {
        if (this.isOpen) return;

        const {
            elements: { btn, collapse, group },
            isInGroup,
            cssHeightProperty,
        } = this;

        btn.setAttribute('aria-expanded', 'true');

        const h = `${collapse.scrollHeight}px`;
        collapse.style.setProperty(cssHeightProperty, h);

        if (isInGroup) {
            const options = { detail: { id: this.ID } };
            group.dispatchEvent(new CustomEvent('ui-accordion-group-open', options));
        }

        this.isOpen = true;
    }

    close() {
        if (this.isClosed) return;

        const {
            elements: { btn, collapse, group },
            isInGroup,
            cssHeightProperty,
        } = this;

        btn.setAttribute('aria-expanded', 'false');
        collapse.style.setProperty(cssHeightProperty, 0);

        if (isInGroup) {
            const options = { detail: { id: this.ID } };
            group.dispatchEvent(new CustomEvent('ui-accordion-group-close', options));
        }

        this.isClosed = true;
    }

    toggleState() {
        if (this.isClosed) this.open();
        else this.close();
    }

    handleHashChange() {
        const ID = this.ID.replace('ui-accordion-', '');
        const hash = window.location.hash.replace('#', '');

        if (ID === hash) this.open();
    }

    listenToggle() {
        const {
            elements: { btn, accordion },
        } = this;

        btn.addEventListener('click', (e) => {
            e.preventDefault();
            this.toggleState();
        });

        accordion.addEventListener('ui-accordion-toggle', ({ detail }) => {
            if ('forceState' in detail) {
                if (detail.forceState) this.open();
                else this.close();
            } else {
                this.toggleState();
            }
        });
    }

    listenHashChange() {
        window.addEventListener('hashchange', () => {
            this.handleHashChange();
        });
    }

    addInGroup() {
        const {
            elements: { group },
        } = this;

        if (!group) return;

        const { UIAccordionGroup } = group;
        if (!UIAccordionGroup) return;

        this.isInGroup = true;
        UIAccordionGroup.addAccordion(this);
    }

    static init() {
        const accordions = document.querySelectorAll('.ui-accordion');
        if (!accordions.length) return;

        accordions.forEach((accordion, index) => {
            const acc = new UIAccordion(accordion); // eslint-disable-line

            if (index === 0) acc.open();
        });
    }
}

export default UIAccordion;
